package it.neckar.lizergy.model.stumps

import it.neckar.lizergy.model.configuration.quote.builder.InverterConfiguration.InverterConfigurationId
import it.neckar.lizergy.model.project.ProjectConfiguration.PhotovoltaicsProjectId
import it.neckar.open.kotlin.serializers.IsoMillis
import it.neckar.uuid.HasUuid
import it.neckar.uuid.NativeUuid
import kotlinx.serialization.Serializable

@Serializable
data class AssemblyBasement(
  override val uuid: NativeUuid,
  val projectId: PhotovoltaicsProjectId,
  val inverterMessdaten: List<InverterMessdaten> = emptyList(),
  val restArbeiten: RestArbeiten = RestArbeiten.empty,
) : HasUuid {
  @Serializable
  data class InverterMessdaten(
    override val inverterConfigurationId: InverterConfigurationId? = null,
    val wetterbedingungen: String? = null,
    val uhrzeit: IsoMillis? = null,
    val monteur: String? = null,
    val bemerkungen: String = "",
  ) : InverterMessdatenEntry

  @Serializable
  data class RestArbeiten(
    val heizstab: Boolean = false,
    val waermepumpe: Boolean = false,
    val batterie: Boolean = false,
    val wallbox: Boolean = false,
    val internetanbindung: Boolean = false,
    val zahlertausch: Boolean = false,
    val kundeneinweisung: Boolean = false,
    val sonstiges: String = "",
  ) {
    val isNotEmpty: Boolean
      get() = heizstab || waermepumpe || batterie || wallbox || internetanbindung || zahlertausch || kundeneinweisung || sonstiges.isNotBlank()

    companion object {
      val empty: RestArbeiten
        get() = RestArbeiten()
    }
  }
}
